import { render, staticRenderFns } from "./kuran-swiper.vue?vue&type=template&id=46dffefc"
import script from "./kuran-swiper.vue?vue&type=script&lang=js"
export * from "./kuran-swiper.vue?vue&type=script&lang=js"
import style0 from "./kuran-swiper.vue?vue&type=style&index=0&id=46dffefc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports